type JSONValue = string | number | boolean | { [key: string]: JSONValue } | Array<JSONValue>;

declare const newrelic: {
    addPageAction: (eventName: string, eventData?: JSONValue) => void;
    setCustomAttribute: (name: string, value?: string | number) => void;
};

const emit = (eventName: string, eventData?: JSONValue) => {
    const newrelicLoaded = typeof newrelic !== 'undefined';

    if (!newrelicLoaded) {
        return;
    }
    newrelic.addPageAction(eventName, eventData);
};

const setCustomAttribute = (name: string, value?: string | number) => {
    const newrelicLoaded = typeof newrelic !== 'undefined';

    if (!newrelicLoaded) {
        return;
    }
    newrelic.setCustomAttribute(name, value);
};

export default { emit, setCustomAttribute };
